// key 埋点key
// attr object结构的埋点数据 { a: 1 }
function send (key, attr, data = '') {
  if (window.Mar && window.Mar.Seed) {
    let mvar = Object.assign({}, window.mars_var, window.inject_mars)
    if (attr) {
      mvar = Object.assign({}, mvar, attr)
    }
    window.Mar.Seed.request('a', 'click', key, mvar, data)
  }
}

const util = {
  send
}

export default util